import React from "react";

export default function Footer() {
    return (
        <div className="footer">
            <a href="https://fontmeme.com/fonts/tesla-font/"><img src="https://fontmeme.com/permalink/220626/95d2c6af7b8ccb48d1870af35537689f.png" alt="tesla-font" border="0"/></a>
        </div>
    )
}